import { useQuery } from '@tanstack/react-query';
import { twinService } from '../../services/twinService';
import { linkCensusKey } from '../../components/twinLinks/linkQueries';

/**
 * FR-017 #7a — how many processed documents have no live twin link: the count
 * behind the Belege page's "Ohne Verknüpfung (n)" entry.
 *
 * Read from the tenant's link census, which uses the same definition as the
 * feed's `view=unlinked`, so the badge and the list cannot disagree. Every link
 * write already calls `refreshLinkQueries`, which invalidates this key too, so
 * linking a document from its panel updates the count. A failed read hides the
 * entry (0): it is an entry point, not a verdict.
 */
export function useUnlinkedCount(): number {
  const { data } = useQuery({
    queryKey: linkCensusKey,
    // A failed read settles as "no census" (0) rather than an error state: the
    // entry is hidden, and the next link write re-reads it.
    queryFn: () => twinService.getLinkCensus().catch(() => null),
    // A census is several aggregate statements; a badge need not re-read it on
    // every mount or window focus. Link writes invalidate it regardless.
    staleTime: 60_000,
  });
  return data?.unrouted?.count ?? 0;
}
